import TaskItem from './TaskItem';

export default function TaskList({ tasks, selectedTaskId, onSelect, onTaskUpdate, onDelete }) {
  if (tasks.length === 0) {
    return (
      <p style={{ color: 'var(--text-dim)', fontSize: 13, textAlign: 'center', padding: 20 }}>
        Aucune tâche. Uploadez un fichier pour commencer.
      </p>
    );
  }

  return (
    <div className="task-list">
      {tasks.map((task) => (
        <TaskItem
          key={task.taskId}
          task={task}
          selected={task.taskId === selectedTaskId}
          onSelect={() => onSelect(task.taskId)}
          onTaskUpdate={onTaskUpdate}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
